import PreliminaryBilling from "@/components/billing/PreliminaryBilling";
import FixedCost from "@/components/billing/FixedCost";

export default [
  {
    path: "/billing/couriers",
    name: "PreliminaryBilling",
    component: PreliminaryBilling,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/billing/fixedCost",
    name: "FixedCost",
    component: FixedCost,
    meta: {
      requiresAuthentication: true
    }
  }
];
